import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'

import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'

export type TableBlockProps = {
  html: string
}

export type TableBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
}>

export function TableBlock<CustomBlockData, extra_images>(
  props: TableBlockProps,
  options?: { style?: TableBlockStyle; key?: string }
  ): (s:CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData,extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<CustomBlockData,extra_images, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
      mk_widget({
        run: onDone => (
          <section
            className={getClassName(options, 'block_classname', '')}
            key={options && options.key ? options.key : 'table-block'}
          >
            <div className={getClassName(options, 'inner_classname', '')}>
              <div 
                className={getClassName(options, 'content_classname', '')} 
                dangerouslySetInnerHTML={{ __html: props.html }}            
              />
            </div>
          </section>
        )
      })
}

export function parseTableHtml(text : string){
  let parser = new DOMParser();
  let html = parser.parseFromString(text, 'text/html');
  let elements = html.querySelectorAll("td");
  elements.forEach(element => {
    if(element.textContent.includes("*")){
      element.setAttribute("class", "td--em");
      element.className= "td--em";
    }
  });
  return html.documentElement.innerHTML;
} 



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/tableBlock.mod.tsx